<div class="layout-col full">
  <mat-toolbar elderTheme class="layout-row place-between-center gap-sm">
    <div class="layout-row gap-sm">
      <button mat-icon-button matDialogClose>
        <mat-icon>close</mat-icon>
      </button>

      <div class="layout-col place-center-start">
        @if (!!title()) {
          <span>{{ title() }}</span>
        } @else {
          {{ 'positions.filters' | translate }}
        }
      </div>
    </div>
  </mat-toolbar>

  <div class="layout-col flex p-md">
    <div class="layout-row wrap">
      @for (constraint of constraints(); track constraint; let i = $index) {
        <app-constraint-input
          class="p-sm"
          [label]="constraint.spec.description"
          [showLabel]="true"
          [allowedValues]="constraint.allowedValues"
          [value]="constraint"
          (valueUpdated)="onValueUpdated($event)"
          [name]="'value' + i"
        >
        </app-constraint-input>
      }
    </div>

    <!--Spacer-->
    <div class="layout-col flex"></div>

    <div class="layout-row place-between-center p-md">
      <button mat-flat-button type="button" name="clear" (click)="onReset()">
        {{ 'context.reset' | translate }}
      </button>

      <button mat-flat-button type="button" name="ok" color="primary" (click)="onSave()">Ok</button>
    </div>
  </div>
</div>
